import { registerSW } from 'virtual:pwa-register';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { AppProviders } from '@/app/AppProviders';
import { router } from '@/app/router';
import '@/i18n';
import '@/theme/global.css';
import '@/shared/ui/ui.css';
import '@/shared/ui/charts/charts.css';

// Registers src/sw.ts (no-op in dev — devOptions.enabled is false, see
// vite.config.ts). `registerType: 'autoUpdate'` means a new version takes
// over silently on the next load, no user-facing update prompt. The same SW
// also carries FCM background push — see src/features/notifications/lib/push.ts.
registerSW({
  immediate: true,
  onRegisterError: (error: unknown) => {
    console.error('[pwa] service worker registration failed', error);
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
